const { PUBLIC_URL } = process.env; // set automatically from package.json:homepage

const data = [
  {
    link: 'https://huggingface.co/will123654',
    label: 'Hugging Face',
    iconSrc: 'https://cdn.simpleicons.org/huggingface?viewbox=auto',
  },
  {
    link: 'https://github.com/will123654',
    label: 'Github',
    iconSrc: 'https://cdn.simpleicons.org/github?viewbox=auto',
  },
  {
    link: 'https://www.linkedin.com/in/wjlee22',
    label: 'LinkedIn',
    iconSrc: `${PUBLIC_URL}/images/linkedin.svg`,
  },
  {
    link: 'mailto:hello@wjlee.me',
    label: 'Email',
    iconSrc: 'https://cdn.simpleicons.org/protonmail?viewbox=auto',
  },
]

export default data;
